<script lang="ts">
  import { onMount } from 'svelte';
  import { listFirms } from '@shared/api/firms';
  import { reqArray, reqRecord } from '@shared/value-objects/parse-helpers';

  /// 表示に必要な最小形。shared は domain (branded Firm) を import できないため、
  /// API の unknown レスポンスからこの形だけを取り出す (value は plain string id)。
  interface FirmOption {
    id: string;
    official_name: string;
    common_name: string | null;
  }

  interface Props {
    /// Currently selected firm id, or `''` for "未選択".
    value: string;
    optional?: boolean;
    placeholder?: string;
    disabled?: boolean;
    id?: string;
    required?: boolean;
  }

  let {
    value = $bindable(''),
    optional = true,
    placeholder = '事務所を選択',
    disabled = false,
    id,
    required = false,
  }: Props = $props();

  let firms = $state<FirmOption[]>([]);
  let loaded = $state(false);
  let error = $state<string | null>(null);

  onMount(async () => {
    try {
      const res = await listFirms({
        page_size: 200,
        sort_by: 'official_name',
        sort_dir: 'asc',
      });
      const items = reqArray(reqRecord(res, 'firms').items, 'firms.items');
      firms = items.map((it) => {
        const o = reqRecord(it, 'firm');
        return {
          id: String(o.id ?? ''),
          official_name: String(o.official_name ?? ''),
          common_name: o.common_name == null ? null : String(o.common_name),
        };
      });
    } catch (err) {
      error = err instanceof Error ? err.message : String(err);
    } finally {
      loaded = true;
    }
  });

  function label(f: FirmOption): string {
    return f.common_name ? `${f.official_name} (${f.common_name})` : f.official_name;
  }
</script>

<select bind:value {id} {disabled} {required}>
  {#if optional}
    <option value="">{placeholder}</option>
  {/if}
  {#each firms as f (f.id)}
    <option value={f.id}>{label(f)}</option>
  {/each}
</select>
{#if !loaded}
  <small class="hint">読込中…</small>
{/if}
{#if error}
  <small class="error">事務所の取得に失敗しました: {error}</small>
{/if}

<style>
  select {
    padding: 8px 10px;
    border: 1px solid #d1d5db;
    border-radius: 4px;
    font: inherit;
    background: #fff;
  }
  .hint { color: #6b7280; font-size: 0.7rem; }
  .error { color: #b91c1c; font-size: 0.7rem; }
</style>
